import React, { useEffect } from "react";
import { RxPencil1 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import {
  setIsTableLoading,
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setTotalItems,
} from "src/redux/slices/UserSlice";
import { RootState } from "src/redux/store";
import { MdDeleteOutline } from "react-icons/md";
import UserRoleListing from "./UserRoleListing";
import { useNavigate } from "react-router-dom";
import {
  useGetAllUserRoleQuery,
  useDeleteUserRoleMutation,
} from "src/services/useraccess/UserAccessServices";
import { UserRoleListTypes } from "src/models/UserRole.model";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

type Props = {};

const UserRoleListingWrapper = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.user);

  const getActionOptions = (row: UserRoleListTypes) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => navigate(`/admin/user-access/${row?.userRoleName}`),
      },
      {
        label: (
          <div className="flex gap-2 items-center text-red-600 font-semibold">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this User role ?",
            icon: "question",
            showCancelButton: true,
            next: (result: any) => {
              if (result.isConfirmed) {
                deleteUserRole(row?._id).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
      },
    ];
  };
  const columns: columnTypes[] = [
    {
      field: "userRoleName",
      headerName: "Role",
      flex: "flex-[1_1_0%]",
      renderCell: (row: UserRoleListTypes) => (
        <div>{row?.userRoleName?.trim()?.replaceAll("_", " ")}</div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: "flex-[0.25_0.25_0%]",
      extraClasses: "",
      renderCell: (row: UserRoleListTypes) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];


  const { data, isLoading, isFetching } = useGetAllUserRoleQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["userRoleName"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  const [deleteUserRole] = useDeleteUserRoleMutation();




  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
    } else {
      dispatch(setIsTableLoading(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  return (
    <div>
      <UserRoleListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.ROLES,
          actionName: UserModuleActionTypes.LIST,
          columns: columns
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onAddNew={() => navigate("/admin/user-access")}
      />
    </div>
  );
};

export default UserRoleListingWrapper;
